import React from "react";
import LightningIcon from "../../../../assets/affiliates/lightningIcon.svg";
import ShadowIcon from "../../../../assets/affiliates/shadow.svg";
import { useTranslation } from "react-i18next";

export const LightningBlock = () => {
  const { i18n } = useTranslation(["affiliates"]);

  return (
    <div className={`lightning-wrapper-mobile-${i18n.dir()}`}>
      <div className="lightning-block">
        <img className="lightning-icon" src={LightningIcon} alt="lightning" />
        <img className="shadow-icon" src={ShadowIcon} />
      </div>
    </div>
  );
};
